import type { FetchRequestError } from "@lib/errors";
import { FetchUserEncodedError } from "@lib/errors/FetchUserEncodedError";
import type { SHARED_CONSTANTS_MULTI_LANGUAGE_COMPOSITION } from "@lib/shared_constants.json";

export type TemplateNotFoundError = FetchUserEncodedError<"TEMPLATE_NOT_FOUND", { template_id: string }>;

export type SameWorkspaceCopyNotSupportedError = FetchUserEncodedError<
  "SAME_WORKSPACE_COPY_NOT_SUPPORTED",
  { template_id: string; app_group_id: string }
>;

export type LocaleNotFoundInTargetWorkspaceError = FetchUserEncodedError<
  SHARED_CONSTANTS_MULTI_LANGUAGE_COMPOSITION["ERROR_CODES"]["LOCALE_NOT_FOUND_IN_TARGET_WORKSPACE"],
  { locale_key: string }
>;

export type NoMatchingLocaleForTranslationError = FetchUserEncodedError<
  SHARED_CONSTANTS_MULTI_LANGUAGE_COMPOSITION["ERROR_CODES"]["NO_MATCHING_LOCALE_FOR_TRANSLATION"],
  { translation_id: string }
>;

export type GetEngagementJumpstartEmailTemplatesErrors =
  | TemplateNotFoundError
  | SameWorkspaceCopyNotSupportedError
  | LocaleNotFoundInTargetWorkspaceError
  | NoMatchingLocaleForTranslationError;

export const isGetEngagementJumpstartEmailTemplatesError = (
  error: FetchRequestError
): error is GetEngagementJumpstartEmailTemplatesErrors => {
  return error instanceof FetchUserEncodedError;
};
